import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(() => ({
  closeButton: {
    position: 'absolute',
    top: 8,
    right: 8,
  },
}));
